import { Component, Input, OnDestroy, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../core/services/analytics.service';

@Component({
	selector: 'app-slider-adds-widget',
	templateUrl: './slider-adds-widget.component.html',
	styleUrls: ['./slider-adds-widget.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SliderAddsWidgetComponent implements AfterViewInit, OnDestroy {
	@Input() slides = [];

	public slider;

	public progressValue = 0;

	public currentInterval;

	constructor(
		private as: AnalyticsService,
		private router: Router,
	) { }

	ngAfterViewInit() {
		const width = (this.slides.length * 100).toString();
		document.getElementById('slide-role').style.width = `${width}%`;
		this.startSlider(1, false);
	}

	startSlider(slide, stopInterval) {
		this.progressValue = slide;
		const slideItem = document.getElementById(`slide${slide}`) as HTMLInputElement;

		if (!slideItem) return;

		slideItem.checked = true;
		if (!stopInterval) {
			this.currentInterval = setInterval(() => {
				if (this.progressValue === this.slides.length) {
					this.progressValue = 0;
				}
				this.progressValue += 1;
				const _slide = document.getElementById(`slide${this.progressValue}`) as HTMLInputElement;
				_slide.checked = true;
			}, 15000);
		} else {
			clearInterval(this.currentInterval);
			// var newSlider = slide;
			this.startSlider(slide, false);
		}
	}

	ngOnDestroy() {
		clearInterval(this.currentInterval);
	}

	goItemLink(item) {
		const index = this.slides.indexOf(item);

		const options = {
			section: 6,
			section_headline: 'Slider Box',
			tile_placement: index + 1,
			tile_headline: item.title,
			cta: item.buttonCTA,
		};

		this.as.homepageTracking(options);

		window.open(item.buttonUrl, '_blank');
	}
}
